 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import A0_FRONTCOVER from '@/components/00_frontcover'
 import A0A_HALFTITLE from '@/components/00a_halftitle'
 import A0C_TITLEPAGE from '@/components/00c_titlepage'
 import A0D_COPYRIGHT from '@/components/00d_copyright'
 import A1_CONTENTS from '@/components/01_contents'
 import A2_ABBRE from '@/components/02_abbre'
 import A3_FM01 from '@/components/03_fm01'
 import A4_FM02 from '@/components/04_fm02'
 import A5_INTRO from '@/components/05_intro'
 import A6_CHAPTER01 from '@/components/06_chapter01'
 import A7_CHAPTER02 from '@/components/07_chapter02'
 import A8_CHAPTER03 from '@/components/08_chapter03'
 import A9_CHAPTER04 from '@/components/09_chapter04'
 import A0_CHAPTER05 from '@/components/10_chapter05'
 import A1_CHAPTER06 from '@/components/11_chapter06'
 import A1_CHAPTER06A from '@/components/11_chapter06a'
 import A2_CHAPTER07 from '@/components/12_chapter07'
 import A3_CHAPTER08 from '@/components/13_chapter08'
 import A4_CHAPTER09 from '@/components/14_chapter09'
 import A5_CHAPTER10 from '@/components/15_chapter10'
 import A6_CHAPTER11 from '@/components/16_chapter11'
 import A7_CHAPTER12 from '@/components/17_chapter12'
 import A8_CHAPTER13 from '@/components/18_chapter13'
 import A9_EPILOGUE from '@/components/19_epilogue'
 import A0_NOTES from '@/components/20_notes'
 import A0_NOTESA from '@/components/20_notesa'
 import A0_NOTESB from '@/components/20_notesb'
 import A1_BIBLIO from '@/components/21_biblio'
 import A2_BM01 from '@/components/22_bm01'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/00_frontcover",
 			"name" : "00_frontcover",
 			"component" : A0_FRONTCOVER
 		},
 		{
 			"path" : "/00a_halftitle",
 			"name" : "00a_halftitle",
 			"component" : A0A_HALFTITLE
 		},
 		{
 			"path" : "/00c_titlepage",
 			"name" : "00c_titlepage",
 			"component" : A0C_TITLEPAGE
 		},
 		{
 			"path" : "/00d_copyright",
 			"name" : "00d_copyright",
 			"component" : A0D_COPYRIGHT
 		},
 		{
 			"path" : "/01_contents",
 			"name" : "01_contents",
 			"component" : A1_CONTENTS
 		},
 		{
 			"path" : "/02_abbre",
 			"name" : "02_abbre",
 			"component" : A2_ABBRE
 		},
 		{
 			"path" : "/03_fm01",
 			"name" : "03_fm01",
 			"component" : A3_FM01
 		},
 		{
 			"path" : "/04_fm02",
 			"name" : "04_fm02",
 			"component" : A4_FM02
 		},
 		{
 			"path" : "/05_intro",
 			"name" : "05_intro",
 			"component" : A5_INTRO
 		},
 		{
 			"path" : "/06_chapter01",
 			"name" : "06_chapter01",
 			"component" : A6_CHAPTER01
 		},
 		{
 			"path" : "/07_chapter02",
 			"name" : "07_chapter02",
 			"component" : A7_CHAPTER02
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js